import PurposeOfRemittance from '../../../types/purposeOfRemittance.type';
import React from 'react';

export const purposeOfRemittanceItemNames: Record<PurposeOfRemittance, string> = {
  [PurposeOfRemittance.COMPUTER_SERVICES]: 'Computer service',
  [PurposeOfRemittance.MAINTENANCE_EXPENSES]: 'Maintenance or other expenses',
  [PurposeOfRemittance.SMALL_VALUE_REMITTANCE]: 'Small value remittance',
  [PurposeOfRemittance.LIBERALIZED_REMITTANCE]: 'Liberalized remittance',
  [PurposeOfRemittance.CONSTRUCTION_EXPENSES]: 'Construction expenses',
  [PurposeOfRemittance.HOTEL_ACCOMMODATION]: 'Hotel accommodation',
  [PurposeOfRemittance.ADVERTISING_EXPENSES]: 'Advertising and/or public relations related expenses',
  [PurposeOfRemittance.ADVISORY_FEES]: 'Fees for advisory or consulting service',
  [PurposeOfRemittance.BUSINESS_INSURANCE]: 'Business related insurance payment',
  [PurposeOfRemittance.INSURANCE_CLAIMS]: 'Insurance claims payment',
  [PurposeOfRemittance.DELIVERY_FEES]: 'Delivery fees',
  [PurposeOfRemittance.EXPORTED_GOODS]: 'Payments for exported goods',
  [PurposeOfRemittance.SERVICE_CHARGES]: 'Payment for services',
  [PurposeOfRemittance.LOAN_PAYMENT]: 'Payment of loans',
  [PurposeOfRemittance.OFFICE_EXPENSES]: 'Office expenses',
  [PurposeOfRemittance.PROPERTY_PURCHASE]: 'Residential property purchase',
  [PurposeOfRemittance.PROPERTY_RENTAL]: 'Property rental payment',
  [PurposeOfRemittance.ROYALTY_FEES]: 'Royalty, trademark, patent and copyright fees',
  [PurposeOfRemittance.SHARES_INVESTMENT]: 'Investment in shares',
  [PurposeOfRemittance.FUND_INVESTMENT]: 'Fund investment',
  [PurposeOfRemittance.TAX_PAYMENT]: 'Tax payment',
  [PurposeOfRemittance.TRANSPORTATION_FEES]: 'Transportation fees',
  [PurposeOfRemittance.UTILITY_BILLS]: 'Utility bills',
  [PurposeOfRemittance.PERSONAL_TRANSFER]: 'Personal transfer',
  [PurposeOfRemittance.REWARD_PAYMENT]: 'Payment of rewards',
  [PurposeOfRemittance.INFLUENCER_PAYMENT]: 'Payment of Influencer',
  [PurposeOfRemittance.OTHER_FEES]: 'Broker, commitment, guarantee and other fees',
  [PurposeOfRemittance.OTHER]: 'Other purposes',
};

export const purposeOfRemittanceItems = Object.values(PurposeOfRemittance);

export const getPurposeOfRemittanceOptionLabel = (purposeOfRemittance: PurposeOfRemittance) => (
  <div style={{ marginTop: '0px' }}>{purposeOfRemittanceItemNames[purposeOfRemittance]}</div>
);

export const purposeOfRemittancePlaceholder = <div style={{ marginTop: '3px' }}>Purpose of Remittance</div>;
